<template>
  <div class="cr-page-404">
    <div class="cr-container">
      <div class="cr-page-404__title">
        {{ $t('notFound.text') }}
      </div>
      <div class="cr-page-404__bottom">
        <a @click="prevPage" class="cr-button cr-button--light">
                        <span class="cr-button__text">
                            {{ $t('notFound.back') }}
                        </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    prevPage() {
      this.$router.go(-1)
    },
  }
}
</script>

